import React from 'react';
import { WidgetDateTime, WidgetLevelLinkText, WidgetSpan, WidgetStatus } from '../../../../components';
import { sortCaret, headerSortingClasses } from '../../../../helpers';
import { status } from '../../../../constants/fraud/fraudConstants';
import { WidgetPrice } from '../../../../components/widget/WidgetPrice';
import { useTranslation } from 'react-i18next';
export default function FraudPreventionColumns () {
    const { t } = useTranslation();
    return [{
        dataField: 'id',
        text: t('fraudPrevention.table.columns.id'),
        sort: true,
        headerClasses: 'clientsColumnsMC_headers--title',
        sortCaret: sortCaret,
        headerSortingClasses
    }, {
        dataField: 'metadata.start',
        text: t('fraudPrevention.table.columns.period'),
        sort: true,
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'left',
        formatter: cellContent => <WidgetSpan text={`fraudPrevention.period.${cellContent}`} />,

        // eslint-disable-next-line react/display-name, react/no-multi-comp
    }, {
        dataField: 'metadata.max_amount',
        text: t('fraudPrevention.table.columns.amount'),
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        formatter: cellContent => (<WidgetPrice number={cellContent} textAlign='left' />),
        // eslint-disable-next-line react/display-name, react/no-multi-comp
    }, {

        dataField: 'metadata.level',
        text: t('fraudPrevention.table.columns.applies'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        headerSortingClasses,
        align: 'center',
        formatter: cellContent => <WidgetLevelLinkText text={`fraudPrevention.levels.${cellContent}`} levelId={cellContent} noBubble/>,
    }, {
        dataField: 'created_at',
        text: t('fraudPrevention.table.columns.created'),
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        align: 'left',
        headerAlign: 'left',
        formatter: cell => <WidgetDateTime date={cell} />,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
    }, {
        dataField: 'updated_at',
        text: t('fraudPrevention.table.columns.updated'),
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        align: 'left',
        headerAlign: 'left',
        formatter: cell => <WidgetDateTime date={cell} />,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
    }, {
        dataField: 'active',
        text: t('fraudPrevention.table.columns.status'),
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        align: 'left',
        headerAlign: 'left',
        formatter: cell => {
            const parsedStatus = status[cell];
            return <WidgetStatus type={parsedStatus.type} text={`fraudPrevention.status.${cell}`} />;
        },
        // eslint-disable-next-line react/display-name, react/no-multi-comp
    }];
}
